// Note: types exposed from `index.d.ts`.
export {location} from './lib/index.js'
